import React from 'react';
import {Navigate, useParams} from 'react-router-dom';
import {useFicha21} from "../../context/UserModulesContext";
import ClientMonitoring from "./ClientMonitoring";

/**
 * Redirect condicional de /client/:id/monitoring y /client/:id/business-units (card gtAL5axI,
 * paso 8). En la 2.1 la pantalla de líneas es la vista del Panel (/client/:id/lines), así que los
 * deep links viejos aterrizan ahí; en el clásico Monitoreo ES la pantalla de líneas y se monta
 * como siempre — `ClientMonitoring.js` no se modifica y ninguna ruta se borra.
 *
 * Hasta que llegan los módulos no se decide nada: redirigir con el flag todavía en false mandaría
 * a un usuario 2.1 a la pantalla equivocada (mismo patrón que ClientDefaultRoute / ClientLines).
 * Es el espejo del guard de /lines (sin ficha21 → /monitoring): como cada usuario tiene UN valor
 * de ficha21, los dos redirects nunca se persiguen.
 */
export default function ClientMonitoringRoute() {
    const {ficha21, loaded} = useFicha21();
    const {id} = useParams();

    if (!loaded) return null;
    if (ficha21) return <Navigate to={`/client/${id}/lines`} replace/>;

    return <ClientMonitoring/>;
}
